<template>
    <div class="wrapper rounded-xl relative will-change-transform" :class="{ 'xl:min-w-[466px] xl:min-h-[369px]': product.type == 'configurable' }">
        <div class="rounded-xl bg-white blur-xl absolute -inset-10 w-[110%] h-[110%]"></div>
        <Splide :options="mainOptions" ref="main" @splide:move="activeSlide" class="main-slide">
            <SplideSlide
                v-for="(image, index) in localImages"
                :key="image.src"
                class="flex justify-center flex-col items-center"
            >
                <vue-picture
                    :image="image"
                    :notlazy="index === 0"
                    @click="showModal()"
                    :width="product.type == 'configurable' ? 369 : 500"
                    :height="product.type == 'configurable' ? 369 : 500"
                    :style="'px-16 md:px-0'"
                    :name="product.name"
                    :loading="index === 0 ? 'eager' : 'lazy'"
                    :fph="index === 0"
                />
            </SplideSlide>
        </Splide>
    </div>

    <Splide :options="thumbsOptions" ref="thumbs" class="thumbs">
        <SplideSlide
            v-for="(image, index) in localImages"
            :key="image.src"
            class="flex justify-center"
        >
            <vue-picture
                :image="image"
                :notlazy="false"
                :width="isMobile ? 50 : 70"
                :height="isMobile ? 50 : 70"
                :name="product.name"
                :fph="false"
                :loading="'lazy'"
                :style="'rounded-md'"
            />
        </SplideSlide>
    </Splide>

    <!-- Todo -> V2 -->
    <!-- <div class="flex flex-wrap rounded-md items-center h-14 space-x-2">
        <h3 class="mr-4">Beschikbare kleuren:</h3>
        <div class="flex flex-wrap space-x-3 items-center">
            <div
                class="w-5 h-5 transition-all duration-300 rounded-full bg-gray-300 ring-2 ring-offset-2 cursor-pointer hover:border-dgreen"
                @click="selectColor('nikkel')"
                :class="selectedColor == 'nikkel' ? 'ring-dgreen' : 'ring-transparent'"
                title="Nikkel"
            ></div>
            <div
                class="w-5 h-5 transition-all duration-300 rounded-full bg-black ring-2 ring-offset-2 cursor-pointer hover:border-dgreen"
                @click="selectColor('black')"
                :class="selectedColor == 'black' ? 'ring-dgreen' : 'ring-transparent'"
                title="Zwart"
            ></div>
            <div
                class="w-5 h-5 transition-all duration-300 rounded-full bg-messing ring-2 ring-offset-2 cursor-pointer hover:border-dgreen"
                @click="selectColor('messing')"
                :class="selectedColor == 'messing' ? 'ring-dgreen' : 'ring-transparent'"
                title="Messing"
            ></div>
        </div>
    </div> -->

    <teleport to="#modals">
        <Modal title="" ref="modal">
            <template v-slot:content>
                <button
                    class="splide__arrow splide__arrow--prev ml-4"
                    type="button"
                    @click="prev"
                    aria-label="Go to last slide"
                    aria-controls="splide09-track"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 40 40"
                        width="40"
                        height="40"
                        focusable="false"
                    >
                        <path
                            d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"
                        ></path>
                    </svg>
                </button>
                <img :src="modalImage" class="mx-auto" />
                <button
                    class="splide__arrow splide__arrow--next mr-4"
                    type="button"
                    @click="next"
                    aria-label="Next slide"
                    aria-controls="splide09-track"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 40 40"
                        width="40"
                        height="40"
                        focusable="false"
                    >
                        <path
                            d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"
                        ></path>
                    </svg>
                </button>
            </template>
        </Modal>
    </teleport>
</template>

<script setup>
import useIsMobile from '@/Composables/useIsMobile';
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import axios from 'axios';
import { onBeforeMount, onMounted, onUnmounted, ref } from 'vue';
const { isMobile } = useIsMobile();

const inBrowser = typeof window !== 'undefined';

const props = defineProps({
    product: Object,
    images: Array,
    color: [String, Boolean],
});

const emit = defineEmits(['update:images']);

const main = ref();
const thumbs = ref();
const modal = ref();
const modalImage = ref(props.images[0].origin_src);
const localImages = ref([...props.images]); // Create a local copy of images

const mainOptions = {
    perPage: 1,
    perMove: 1,
    gap: '1rem',
    pagination: false,
    waitForTransition: true,
    preloadPages: 1,
    trimSpace: true,
    resizeObserver: false,
    speed: 400,
    easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
    updateOnMove: false,
    focus: 'center',
    lazyLoad: 'nearby',
    breakpoints: {
        640: {
            gap: '0.5rem',
        }
    }
};

const thumbsOptions = {
    gap: '0.5rem',
    pagination: false,
    perPage: 8,
    // arrows: true,
    cover: true,
    focus: props.product.type == 'configurable' ? 'center' : 'left',
    isNavigation: true,
    updateOnMove: false,
    waitForTransition: true,
    preloadPages: 1,
    trimSpace: true,
    resizeObserver: false,
    speed: 400,
    easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
    perMove: 3,
    lazyLoad: 'nearby',
    breakpoints: {
        640: {
            perPage: 6,
            // arrows: true,
            fixedWidth: 50,
            fixedHeight: 50,
            gap: '0.2rem'
        },
    },
    fixedWidth: 70,
    fixedHeight: 70,
};

const activeSlide = (slide) => {
    currentIndex.value = slide.index;
    modalImage.value = props.images[slide.index].origin_src;
};

const next = () => {
    document.querySelector('.splide__arrow--next').click();
};

const prev = () => {
    document.querySelector('.splide__arrow--prev').click();
};

const showModal = () => {
    if (inBrowser) {
        modal.value.open = true;
    }
};

const currentIndex = ref(0);

// const selectColor = (color) => {
//     selectedColor.value = color;
// };

// Cache image dimensions
const imageDimensions = new Map();

const cacheImageDimensions = (image) => {
    if (!imageDimensions.has(image.src)) {
        const img = new Image();
        img.onload = () => {
            imageDimensions.set(image.src, {
                width: img.width,
                height: img.height,
            });
        };
        img.src = image.src;
    }
};

const shoppingImage = (value) => {
    axios
        .get('/configurable/shopping/' + props.product.id + '/' + value, {
            params: { kleur: props.color },
        })
        .then((response) => {
            if (response.data != localImages.value[0]) {
                localImages.value[0] = response.data;
                modalImage.value = response.data.origin_src;
                emit('update:images', localImages.value);
            }
        })
        .finally(() => {});
};

onBeforeMount(() => {
    if (props.product.type == 'configurable' && inBrowser) {
        window.mitt.on('updateShoppingImage', shoppingImage);
    }
    // Pre-cache first few images
    props.images.slice(0, 3).forEach(cacheImageDimensions);
});

onUnmounted(() => {
    if (props.product.type == 'configurable' && inBrowser) {
        window.mitt.off('updateShoppingImage', shoppingImage);
    }
    imageDimensions.clear();
});

onMounted(() => {
    const thumbsSplide = thumbs.value?.splide;
    if (thumbsSplide) {
        main.value?.sync(thumbsSplide);
        
        const showArrows = thumbsSplide.length > thumbsSplide.options.perPage;
        thumbsSplide.options = { ...thumbsSplide.options, arrows: showArrows };
    }
});
</script>
